import { getSafeParam, isSafeNavigationParam, isSafeTicket, isSafeUrl } from "./ValidateInput";
import { sendLog } from "./sendLog";
export const checkParameters = (rawParameters, pathConfig) => {
    var _a, _b;
    const validatedParameters = {
        gameid: getSafeParam(rawParameters, "gameid"),
        gameurl: getSafeParam(rawParameters, "gameurl", isSafeUrl),
        channel: getSafeParam(rawParameters, "channel"),
        gameref: getSafeParam(rawParameters, "gameref"),
        lobbyid: getSafeParam(rawParameters, "lobbyid"),
        provider: getSafeParam(rawParameters, "provider"),
        clientid: getSafeParam(rawParameters, "clientid"),
        currency: getSafeParam(rawParameters, "currency"),
        hidehome: getSafeParam(rawParameters, "hidehome"),
        jurisdiction: getSafeParam(rawParameters, "jurisdiction"),
        lang: getSafeParam(rawParameters, "lang"),
        moneymode: getSafeParam(rawParameters, "moneymode"),
        partnerid: getSafeParam(rawParameters, "partnerid"),
        partner: getSafeParam(rawParameters, "partner"),
        ticket: getSafeParam(rawParameters, "ticket", isSafeTicket),
        fullscreen: getSafeParam(rawParameters, "fullscreen"),
        beyondplay: getSafeParam(rawParameters, "beyondplay"),
        integration: getSafeParam(rawParameters, "integration"),
        configurl: getSafeParam(rawParameters, "configurl", isSafeUrl),
        gamelocation: getSafeParam(rawParameters, "gamelocation", isSafeUrl),
        rciframeurl: getSafeParam(rawParameters, "rciframeurl", isSafeUrl),
        tester: getSafeParam(rawParameters, "tester"),
        api: getSafeParam(rawParameters, "api"),
        excludefrompromo: getSafeParam(rawParameters, "excludefrompromo"),
        verifyorigin: rawParameters.get("verifyorigin") === "true" ? "true" : null,
        apex: getSafeParam(rawParameters, "apex"),
        homeurl: getSafeParam(rawParameters, "homeurl", isSafeNavigationParam),
        rchistoryurl: getSafeParam(rawParameters, "rchistoryurl", isSafeNavigationParam),
        rg_se_uri: getSafeParam(rawParameters, "rg_se_uri", isSafeNavigationParam),
        rg_st_uri: getSafeParam(rawParameters, "rg_st_uri", isSafeNavigationParam),
        rg_sl_uri: getSafeParam(rawParameters, "rg_sl_uri", isSafeNavigationParam),
        rg_account_uri: getSafeParam(rawParameters, "rg_account_uri", isSafeNavigationParam),
        rg_pause_uri: getSafeParam(rawParameters, "rg_pause_uri", isSafeNavigationParam),
        layerconfigurl: getSafeParam(rawParameters, "layerconfigurl", isSafeUrl)
    };
    const issues = [];
    for (const key of Object.keys(validatedParameters)) {
        if (validatedParameters[key] !== rawParameters.get(key)) {
            issues.push(`(${key}): ${(_a = rawParameters.get(key)) !== null && _a !== void 0 ? _a : "null"} validated to ${(_b = validatedParameters[key]) !== null && _b !== void 0 ? _b : "null"}`);
        }
    }
    if (issues.length) {
        sendLog("Non-standard parameters used: " + issues.join(" / "), pathConfig);
    }
};
